(() => {
  const source = document.getElementById('seven-catalog-labels');
  if (!source) return;
  let catalog;
  try { catalog = JSON.parse(source.textContent); } catch { return; }
  const decode = (value) => value.replace(/&(?:amp|quot|lt|gt|#39|#x27);/g, (entity) => ({'&amp;': '&', '&quot;': '"', '&lt;': '<', '&gt;': '>', '&#39;': "'", '&#x27;': "'"})[entity]);
  catalog.home = decode(catalog.home);
  const labels = Object.fromEntries(Object.entries(catalog.labels || {}).map(([key, value]) => [key, decode(value)]));
  const collectionHandle = (value) => {
    try {
      const path = new URL(value, location.origin).pathname;
      const match = path.match(/\/collections\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch { return ''; }
  };
  const labelForUrl = (value) => labels[collectionHandle(value)];
  const setText = (element, value) => {
    if (element && value && element.textContent.trim() !== value) element.textContent = value;
  };
  let scheduled = false;
  const update = () => {
    scheduled = false;
    document.querySelectorAll('.oh-card-categories').forEach((card) => {
      const link = card.querySelector('a[href*="/collections/"]');
      const label = link && labelForUrl(link.href);
      const image = card.querySelector('img');
      if (image && image.sizes !== '(max-width: 749px) 48px, 56px') image.sizes = '(max-width: 749px) 48px, 56px';
      if (!label) return;
      setText(card.querySelector('.oh-card-categories__heading'), label);
    });
    document.querySelectorAll('.oh-item-slider-button[name="previous"], .oh-item-slider-button[name="next"]').forEach((button) => {
      const label = catalog[button.name];
      if (label && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
    });
    const currentLabel = labels[collectionHandle(location.href)];
    setText(document.querySelector('.seven-collection-banner h1'), currentLabel);
    document.querySelectorAll('[data-obc-breadcrumb-server]').forEach((trail) => {
      trail.querySelectorAll('a[href]').forEach((link) => {
        const label = labelForUrl(link.href);
        if (label) {
          setText(link, label);
          if (link.getAttribute('aria-label') !== label) link.setAttribute('aria-label', label);
        } else if (/^\/(?:ar\/?)?$/.test(new URL(link.href).pathname)) {
          if (link.getAttribute('aria-label') !== catalog.home) link.setAttribute('aria-label', catalog.home);
        }
      });
      if (currentLabel) setText(trail.querySelector('[data-state="active"]'), currentLabel);
    });
    document.querySelectorAll('script[data-obc-breadcrumb-schema]').forEach((script) => {
      try {
        const original = script.textContent;
        const schema = JSON.parse(original);
        let changed = false;
        for (const item of schema.itemListElement || []) {
          const url = typeof item.item === 'string' ? item.item : item.item?.['@id'];
          if (!url) continue;
          let label = labelForUrl(url);
          if (!label && /^\/(?:ar\/?)?$/.test(new URL(url, location.origin).pathname)) label = catalog.home;
          if (label && item.name !== label) { item.name = label; changed = true; }
        }
        if (changed) script.textContent = JSON.stringify(schema);
      } catch {}
    });
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  update();
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  document.addEventListener('shopify:section:load', schedule);
  addEventListener('popstate', schedule);
})();
